import { useQuery } from '@tanstack/react-query';
import { configApi, type AppConfig } from '@/api/config';

const FALLBACK: AppConfig = {
  venmoHandle: null,
  paypalHandle: null,
  machineName: 'Home Slots',
};

/**
 * Public env-driven config (Venmo/PayPal handles + default machine name).
 * Held in TanStack Query with a long stale time because it only changes
 * when the server restarts with a different .env — never per-user, never
 * per-route.
 *
 * Returns the parsed config when ready; falls back to a safe shape while
 * loading so callers don't have to guard against undefined.
 */
export function useAppConfig(): AppConfig {
  const q = useQuery<AppConfig>({
    queryKey: ['app', 'config'],
    queryFn: configApi.get,
    staleTime: 24 * 60 * 60 * 1000, // 1 day — env changes require a server restart
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  return q.data ?? FALLBACK;
}
